import { render, staticRenderFns } from "./BpcFormCreateDocument.vue?vue&type=template&id=5a47e35b&"
import script from "./BpcFormCreateDocument.vue?vue&type=script&lang=js&"
export * from "./BpcFormCreateDocument.vue?vue&type=script&lang=js&"
import style0 from "./BpcFormCreateDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports